import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";
import { Link } from "gatsby";

function Banner(props) {
  return (
    <div className="services_location_banner">
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={7} xxl={7} className="my-auto">
            <div className="banenr_content">
              <div className="example" data-text="Atlanta">
                <h1>Mobile App Development Company In Atlanta</h1>
              </div>
              <p className="main_para">
                TekRevol is a leading mobile app development company in Atlanta
                that builds feature-rich, state-of-the-art mobile applications
                for businesses worldwide. We have a proven track record of
                facilitating customers with their app ideas and turning them
                into epic digital solutions. With our core focus on performance
                metrics like seamless navigation, usability, and quick delivery
                of the app, we help businesses obtain a strong digital presence.
              </p>
              <Link
                to="/contact"
                className="border_btn dark_btn"
                aria-label="TekRevol Contact"
              >
                {" "}
                Let’s Get Started
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={5} xxl={5} className="my-auto">
            <Bannerfrom />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
